module.exports = __webpack_public_path__ + "static/cadastro_1-0062fcceebc1b8a3d879b06534bd59ba.png";